import { render } from "./BulletCard.vue?vue&type=template&id=04188778&scoped=true"
import script from "./BulletCard.vue?vue&type=script&lang=js"
export * from "./BulletCard.vue?vue&type=script&lang=js"

import "./BulletCard.vue?vue&type=style&index=0&id=04188778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04188778"]])

export default __exports__